import { useMemo } from 'react';
import { DynamicForm } from 'src/components';
import { CONTAINER_CLASS, LabelField } from 'src/components/Fields/LabelField';
import type { SidePanelRowProps } from 'src/graphql/entities/side-panel-personalization/model/descriptors';
import { useSiteCardForm } from './site-card-form-context';

/**
 * One associated-site form field as an ordered panel row. Each row is its own
 * single-field watchable form; useUpdateAssociatedSite already accepts the
 * per-field partial that watchableSubmitOnlyChangedField submits.
 */
export const SiteCardFieldRow = ({ propertyKey }: SidePanelRowProps) => {
  const { fieldsByKey, onSubmit } = useSiteCardForm();
  const field = fieldsByKey[propertyKey];

  // a watchable DynamicForm resets RHF state off its `fields` identity — an
  // inline array here would re-reset (and re-submit) on every render
  const rowFields = useMemo(() => (field ? [field] : []), [field]);

  if (!field) {
    return null;
  }

  return (
    <DynamicForm
      watchable
      watchableSubmitOnlyChangedField
      fields={rowFields}
      onSubmit={onSubmit}
    />
  );
};

export const SiteCardLabelsRow = () => {
  const { address, disabled, labelAssignments, canAccessPrivateLabels } = useSiteCardForm();

  return (
    <LabelField
      entityId={address.addressId}
      entityName="Address"
      partnerId={address.partnerId}
      labelAssignments={labelAssignments ?? []}
      isEditable={!disabled}
      paddingInline={2}
      canAccessToPrivateLabels={canAccessPrivateLabels}
      className={CONTAINER_CLASS}
    />
  );
};
